<template>
    <div class="col-12">
      <div class="search-padd">
      <form @change="captureModificationsEvent" v-on:submit.prevent>
        <div class="col-xs-12 override-padding">
          <div class="crm_admin_heading admin_heading_22 text-align-left">+/-</div>
          <div class="crm_admin_heading group_heading_2 text-align-left">Group Name</div>
          <div class="crm_admin_heading group_heading_3 text-align-left">Parent Group</div>
          <div class="crm_admin_heading group_heading_4 text-align-left">Instructor</div>
          <div class="crm_admin_heading group_heading_5 text-align-left ">Task Lists</div>
          <div class="crm_admin_heading admin_heading_22 text-align-center">&nbsp;</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div v-for="(account_group, index) in account_groups">

          <div v-bind:class="'admin_details' + index" v-bind:id="'mentee_details_more' + index">
            <div
              class="crm_admin_field_lists admin_heading_22 text-align-center font-25 line-height-30 cursor-pointer">
              <a v-b-toggle="'collapse_' + index">
              <span class="when-opened">-</span> <span class="when-closed">+</span>
              </a>
            </div>
            <div class="crm_admin_field_lists group_heading_2 text-align-left">
              <div class="search-padd">
              <input
                  type="hidden"
                  v-bind:name="'gid[' + index + ']'"
                  v-bind:id="'gid_' + index"
                  v-model="account_group.gid">
                <input
                    type="text"
                    v-bind:id="'group_name_' + index"
                    class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                    ref="group_name"
                    v-bind:name="'group_name[' + index + ']'"
                    v-model="account_group.group_name"
                    v-validate="{ rules: { required: true, regex: nameRegex() } }"
                    placeholder="Group Name"
                    maxlength="250">
                <div v-if="verrors.firstByRule('group_name[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Group name is required</div>
              </div>
            </div>
            <div class="crm_admin_field_lists group_heading_3 text-align-left">
              <div class="search-padd">
                <b-form-select
                    class="col-md-12 input-height-30 padding-lr-5 margin-bottom-5"
                    v-model="account_group.parent_group"
                    v-bind:name="'parent_group[' + index + ']'"
                    :options="parent_group_options"
                    >
                    </b-form-select>

              </div>
            </div>
            <div class="crm_admin_field_lists group_heading_4 text-align-left">
              <div class="search-padd" id="mentee-group-wrapper">
                <multiselect v-model="account_group.instructor_assigned"
                  :options="instructors"
                  track-by="name"
                  label="name"
                  v-validate="'required'"
                  v-bind:name="'instructor_assigned[' + index + ']'"
                  v-bind:id="'instructor_assigned_' + index"
                  placeholder="Select"
                  :multiple="true"
                  :close-on-select="false"
                  :show-labels="false"
                  @input="updateGroupsDetailsEvent(index, 'instructor_assigned', account_group.instructor_assigned)"
                  >
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                </multiselect>
                <div v-if="verrors.firstByRule('instructor_assigned[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Instructor is required</div>
              </div>
            </div>
            <div class="crm_admin_field_lists group_heading_5 text-align-left">
              <div class="search-padd" id="mentee-tasklist-wrapper">
                <multiselect
                  v-model="account_group.tasklists_assigned"
                  :options="taskLists"
                  track-by="name" label="name"
                  v-bind:name="'tasklists_assigned[' + index + ']'"
                  v-bind:id="'tasklists_assigned_' + index"
                  placeholder="Select"
                  :multiple="true"
                  :close-on-select="false"
                  :show-labels="false"
                  @input="updateGroupsDetailsEvent(index, 'tasklists_assigned', account_group.tasklists_assigned)"
                  >
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                </multiselect>
             </div>
            </div>

            <div class="crm_admin_field_lists admin_heading_22 text-align-center">
              <div class="search-padd delete-icon" style="" v-if="account_groups.length > 1">
                  <i class="fa fa-window-close cursor-pointer"
                    aria-hidden="true" @click="removeGroup(index)"></i>
              </div>
            </div>

          </div>
          <div style="clear: both;"></div>
          <b-collapse v-bind:id="'collapse_' + index" class="">
          </b-collapse>

        </div>
        <button
            v-on:click="addGroup()"
            v-if="this.account_groups.length < 50"
            class="btn btn-red btn-group-sm"
            >
             <b><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Add Group</b>
        </button>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <DeleteModal :isModalVisible="isDeleteModalVisible" :id="delete_id" :parent_id="parent_id" @close="isDeleteModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">Are you sure you want to delete the group?</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
            <button class="left col-12 btn btn-red" @click="isDeleteModalVisible = false; deleteGroupAction(delete_id)">Confirm</button>
          </div>
        </DeleteModal>
        </form>
      </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import DeleteModal from '../shared/delete_modal_alert.vue';
import Multiselect from 'vue-multiselect';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
      props: ['accountId'],
      data() {
        return {
          account_groups: [],
          taskLists: [],
          instructors: [],
          loading: false,
          isDeleteModalVisible: false,
          parent_id: '',
          delete_id: '',
          updated_account_groups: [],
          account_type: '',
          parent_group_options: [],
        }
      },
      components: {
         Multiselect,
         DeleteModal,
      },
      methods: {
        nameRegex: function() {
          return /^[\w- ']*$/;
        },
        removeGroup: function(index) {
          this.isDeleteModalVisible = true;
          this.delete_id = index;
        },
        deleteGroupAction: function(index) {
          if(this.account_groups[index].gid == 0) {
            this.account_groups.splice(index, 1);
          }
          else {
            /* Soft Delete */
            axios('/groups/' + this.account_groups[index].gid,
               {
                 method: 'DELETE',
               }
             )
            .then((resp) => {
                this.updated_account_groups = {};
                this.getGroupListData();
            })
            .catch(error => {

            });
          }
        },
        addGroup: function() {
          this.account_groups.push({
            gid: 0,
            group_name: '',
            parent_group: '',
            tasklists_assigned: [],
            instructor_assigned: [],
          });
        },
        getGroupListData: function() {
          axios('/accountgroups',
            {
              method: 'GET',
              params: {
                account_id: this.accountId,
              }
            },
          )
          .then(response => {
              this.parent_group_options = [];
              var group = {value: '', text: 'Select Parent Group'};
              this.parent_group_options.push(group);
              for(var i=0; i < response.data.length; i++) {
                var group = {value: response.data[i].id, text: response.data[i].groupName};
                this.parent_group_options.push(group);
              }
           })
          .catch(error => {

          });

          axios("/account_lookup_group_list", {
            method: 'GET',
            params: {
              account_id: this.accountId,
            }
          })
          .then(response => {
            this.loading = false;
            this.account_groups = response.data;

            if(this.account_groups.length == 0) {
              this.account_groups.push({
                gid: 0,
                group_name: '',
                parent_group: '',
                tasklists_assigned: [],
                instructor_assigned: [],
              });
            }
          })
          .catch(error => {

          });

        },

        updateGroupsDetailsEvent: function(index, field, value) {
          if(this.account_groups[index].gid > 0) {
            if(this.updated_account_groups[index]) {
              Vue.set(this.updated_account_groups[index], field, value);
            }
            else {
              this.updated_account_groups[index] = {};
              Vue.set(this.updated_account_groups[index], 'gid', this.account_groups[index].gid);
              Vue.set(this.updated_account_groups[index], field, value);
            }
          }
        },
        captureModificationsEvent ({ type, target }) {
          var regex = /\d+/g;
          var name = target.name;
          var matches = name.match(regex);
          if(this.account_groups[matches].gid > 0) {
            var value;
            value = target.value;

            var field = name.replace("["+matches+"]", "");
            this.updateGroupsDetailsEvent(matches, field, value);
          }

        },

        onSelect (op) {

        },
      },
      created: function () {
        this.account_type = this.$parent.org_type;
        this.loading = true;

        this.getGroupListData();

        axios('/alltasklists-account',
          {
            method: 'GET',
            params: {
              account_id: this.accountId,
            }
          },
        )
        .then(response => {
            for(var i=0; i < response.data.length; i++) {
              var tasklistItem = {value: response.data[i].id, name: response.data[i].name};
              this.taskLists.push(tasklistItem);
            }
         })
        .catch(error => {

        });

        axios('/instructors-account',
          {
            method: 'GET',
            params: {
              account_id: this.accountId,
            }
          },
        )
        .then(response => {
            for(var i=0; i < response.data.length; i++) {
              var instructorItem = {value: response.data[i].id, name: response.data[i].name};
              this.instructors.push(instructorItem);
            }
         })
        .catch(error => {

        });
      },
    }
</script>


<style>
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect__single {
  font-size: 14px !important;
  margin-bottom: 4px !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_group_tab.vue